export const runSequentialMarkAsUpdates = async (ids, updateOne) => {
  const succeededIds = [];
  let firstError = null;
  for (const id of ids) {
    try {
      await updateOne(id);
      succeededIds.push(id);
    } catch (error) {
      if (!firstError) firstError = error;
    }
  }
  return {
    total: ids.length,
    succeeded: succeededIds.length,
    failed: ids.length - succeededIds.length,
    succeededIds,
    firstError,
  };
};

export const promotionMarkAsResultAlert = ({
  total,
  succeeded,
  firstError,
  actionLabel,
}) => {
  if (succeeded === total && total > 0) {
    return {
      ok: true,
      type: "success",
      timeout: "2500",
      message: total > 1 ? `Updated ${succeeded} employees` : actionLabel,
    };
  }
  const errorMessage =
    firstError?.data?.message ||
    firstError?.message ||
    "Unable to update status";
  if (succeeded > 0) {
    return {
      ok: false,
      type: "error",
      timeout: "4000",
      message: `Updated ${succeeded} of ${total} employees. ${errorMessage}`,
    };
  }
  return {
    ok: false,
    type: "error",
    timeout: "3000",
    message: errorMessage,
  };
};
